import React from 'react';
import { UserCheck, RefreshCw, AlertCircle } from 'lucide-react';
import { useI18n } from '../../context/I18nContext';
import { FaqCategory } from '../../types';

export interface SupportCategoryListProps {
  onSelectCategory?: (category: FaqCategory) => void;
  activeCategory?: FaqCategory | null;
}

export const SupportCategoryList: React.FC<SupportCategoryListProps> = ({
  onSelectCategory,
  activeCategory,
}) => {
  const { locale } = useI18n();

  const categories = [
    {
      id: 'account' as FaqCategory,
      icon: UserCheck,
      title: locale === 'ko' ? '계정 및 로그인' : 'Account & Login',
      desc: locale === 'ko' ? '로그인 오류, 계정 연동 및 영구 삭제 요청' : 'Login issues, authentication & account deletion',
    },
    {
      id: 'troubleshooting' as FaqCategory,
      icon: RefreshCw,
      title: locale === 'ko' ? '데이터 동기화 & 백업' : 'Data & Syncing',
      desc: locale === 'ko' ? '기기 변경 시 복원, 오프라인 저장 안내' : 'Device transfer, local backup & restore guides',
    },
    {
      id: 'general' as FaqCategory,
      icon: AlertCircle,
      title: locale === 'ko' ? '오류 제보 & 사용법' : 'Troubleshooting & Bugs',
      desc: locale === 'ko' ? '앱 비정상 종료, 위젯 오류 및 기능 제안' : 'Crash reports, widget issues & feature requests',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {categories.map((cat) => {
        const IconComponent = cat.icon;
        const isSelected = activeCategory === cat.id;

        return (
          <button
            key={cat.id}
            type="button"
            onClick={() => onSelectCategory && onSelectCategory(cat.id)}
            className={`text-left p-5 rounded-2xl border transition-all duration-200 shadow-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 ${
              isSelected
                ? 'bg-primary-50/70 border-primary-400 shadow-sm ring-1 ring-primary-300'
                : 'bg-white border-slate-200/90 hover:border-slate-300 hover:bg-slate-50/80 hover:-translate-y-0.5'
            }`}
          >
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 ${
              isSelected ? 'bg-primary-500 text-white' : 'bg-slate-100 text-slate-700'
            }`}>
              <IconComponent className="w-5 h-5" />
            </div>
            <h4 className="font-bold text-slate-900 text-base mb-1">
              {cat.title}
            </h4>
            <p className="text-xs text-slate-500 leading-relaxed">
              {cat.desc}
            </p>
          </button>
        );
      })}
    </div>
  );
};
